import styled from 'styled-components';
import { media, spaceInPx, Box } from '@leagueplatform/ui-kit';

export const InfoCardContent = styled(Box)`
  margin: 4rem 5rem;
  ${media.belowDesktop`
    margin: ${spaceInPx(3)}
  `};
`;
